import MagnifyingGlass from '../../src/legacy/MagnifyingGlass.tsx';
export default MagnifyingGlass;
